import React, { useState, useEffect, useCallback } from 'react';
import { MessageCircle } from 'lucide-react';
import { SCROLL_THRESHOLD_STICKY_CTA } from '../../constants/pricing';
import { openWhatsApp } from '../../lib/whatsapp';

const WHATSAPP_MESSAGE =
  'Namaste Nitika Ji, I would like to book a consultation.';

export const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);

  const handleWhatsAppClick = useCallback(() => {
    openWhatsApp(WHATSAPP_MESSAGE);
  }, []);

  const handleScroll = useCallback(() => {
    setIsVisible(window.scrollY > SCROLL_THRESHOLD_STICKY_CTA);
  }, []);

  const handleChatToggle = useCallback((e) => {
    setChatOpen(!!e.detail?.open);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('chat:toggle', handleChatToggle);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('chat:toggle', handleChatToggle);
    };
  }, [handleScroll, handleChatToggle]);

  if (!isVisible || chatOpen) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <div className="bg-gradient-to-t from-[#0A0000] via-[#0A0000]/95 to-transparent pt-4 pb-4 px-4">
        <button
          onClick={handleWhatsAppClick}
          className="w-full bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-black font-bold text-base py-4 rounded-full flex items-center justify-center gap-3 shadow-[0_10px_40px_rgba(212,175,55,0.35)]"
          data-testid="sticky-mobile-cta"
        >
          <MessageCircle className="w-5 h-5" />
          Book a Consultation on WhatsApp
        </button>
      </div>
    </div>
  );
};
